import { Breakpoints } from '@apps/gated-2021/breakpoints';
import { Colors } from '@src/colors';
import styled from 'styled-components';

/**
 * Styled component that defines the layout for an input form.
 *
 * Child components should extend one of the following components:
 * @see {Back} - (Optional) The form back button
 * @see {Title} - The form title
 * @see {Subtitle} - The form subtitle container
 * @see {Input} - The form input container
 */
export const Form = styled.div`
    display: grid;
    grid-template-areas:
        'back'
        'title'
        'subtitle'
        'input'
        'footer';

    margin: auto 0;
`;

export const Back = styled.div`
    grid-area: back;

    font-family: 'Public Sans';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.7px;
    text-align: left;
    margin: 0;
`;

export const Title = styled.h1`
    color: white;
    grid-area: title;
    font-family: 'STIX Two Text', serif;
    font-weight: 600;
    line-height: 88px;
    font-size: 67px;
    letter-spacing: 1px;
    font-feature-settings:
        'ss02' on,
        'ss06' on;

    margin: 33px 0 50px 0;

    @media screen and (max-width: ${Breakpoints.font}) {
        font-size: 45px;
        line-height: 50px;
    }

    @media screen and (max-width: ${Breakpoints.mobile}) {
        margin: 26px 30px 40px 30px;
        font-style: normal;
        font-size: 38px;
        line-height: 40px;
        text-align: center;
    }

    @media screen and (max-width: ${Breakpoints.mobileSmall}) {
        white-space: pre-line;
    }

    @media print {
        color: ${Colors.midnight};
    }
`;

export const Subtitle = styled.h2<{ bold?: boolean }>`
    color: white;
    grid-area: subtitle;
    font-family: 'Public Sans';
    font-weight: ${(prop) => (prop.bold ? '800' : 'normal')};
    font-size: 21px;
    letter-spacing: 0.5px;
    line-height: 28px;

    font-feature-settings:
        'ss06' on,
        'ss02' on,
        'salt' on,
        'ss01' on;

    margin: 0 0 32px 0;

    @media screen and (max-width: ${Breakpoints.mobile}) {
        font-weight: 500;
        margin: 0 30px 35px 30px;
        text-align: center;
    }

    @media screen and (max-width: ${Breakpoints.mobileSmall}) {
        white-space: pre-line;
    }

    @media print {
        color: ${Colors.midnight};
    }
`;
export const Footer = styled.h3`
    grid-area: footer;

    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 800;
    font-size: 21px;
    line-height: 28px;

    letter-spacing: 0.5px;
    font-feature-settings:
        'ss06' on,
        'ss02' on,
        'salt' on,
        'ss01' on;

    color: #ffffff;

    flex: none;
    order: 1;
    flex-grow: 0;
    margin: 63px 0px 0px 0px;

    @media screen and (max-width: ${Breakpoints.mobile}) {
        margin: 33px 0 0 0;
        text-align: center;
        font-family: 'Public Sans';
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
    }
`;

export const Input = styled.div`
    grid-area: input;

    @media screen and (max-width: ${Breakpoints.mobile}) {
        font-weight: 500;
        margin: 0 30px;
        justify-self: center;
    }
`;
